"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setActivePage = exports.SET_ACTIVE_PAGE = void 0;
var SET_ACTIVE_PAGE = exports.SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE';
var setActivePage = exports.setActivePage = function setActivePage(payload) {
  return {
    type: SET_ACTIVE_PAGE,
    payload: payload
  };
};